import NotFound from '@/components/PageNotFound/NotFound'

const NotFoundScreen = () => {
  return <NotFound />
}

export default NotFoundScreen
